






































import Vue from 'vue';
import { API } from '@/api';
import { mapActions } from 'vuex';

export default Vue.extend({
  props: {
    ingresoInit: Array,
    disabled: Boolean,
  },
  data: () => ({
    openDialog: false,
    options: {page: 1, itemsPerPage: 100000, sortBy: 0},
    unidades: [],
    unidad: {},
  }),
  // mounted() {
  // },
  methods: {
    async getUnidades() {
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const options = this.options;
      const datos = {admin, condo};
      // console.log('getUnidades');
      const result = await this.$store.dispatch('getUnidadesPropList', {datos, options});
      this.unidades = result.content;
      // console.log('Update getUnidades: ', result);
    },
    async addUnidad() {
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const unidad = this.unidad;
      const ingreso = this.ingresoInit[0];
      const datos = {admin, condo, unidad, ingreso};
      // console.log('Datos: ', datos);
      const result = await this.$store.dispatch('getAddUnidadIncome', datos);
      // console.log('Result Add: ', result);
      this.$emit('reloadGrid', {});
      this.closeDialog();
    },
    closeDialog() {
      this.openDialog = false;
      this.unidad = {};
    },
  },
  // computed: {
  // },
  watch: {
    openDialog() {
      if (this.openDialog) {
        this.getUnidades();
      }
    },
  },
});
